@if (bankAccountAssignments?.hasBankAccounts) {
  <div>
    <div class="re-mb-5">
      {{ 'dashboard.banking.description' | translate }}
    </div>
    <div class="bold" data-qa="debit-assignment">
      @if (bankAccountAssignments?.debit) {
        <div>{{ bankAccountAssignments?.debit?.bankname}}:&nbsp;{{ bankAccountAssignments?.debit?.iban}}</div>
      } @else {
        {{ 'banking.assignment.noDebit' | translate }}
      }
    </div>
    @if (bankAccountAssignments?.debit !== bankAccountAssignments?.credit) {
      @if (bankAccountAssignments?.credit) {
        <div data-qa="credit-assignment">
          <div class="bold re-mt-30">{{ 'dashboard.banking.credit' | translate }}:</div>
          {{ bankAccountAssignments?.credit?.bankname}}:&nbsp;{{ bankAccountAssignments?.credit?.iban}}
        </div>
      } @else {
        <div class="re-mt-45" data-qa="manual-credit">
          {{ 'personaldata.banking.manualCredit' | translate }}
        </div>
      }
    }
  </div>
}
@if (!bankAccountAssignments?.debit) {
  <div class="re-mb-default">
    <div [ngClass]="bankAccountAssignments?.debit === bankAccountAssignments?.credit ? 're-mt-90' : 're-mt-15'">
      <div data-qa="sepa-hint">
        {{ 'dashboard.banking.withoutSepaWithBankAccounts' | translate }}
      </div>
    </div>
  </div>
}
